<template>
  <ContainerWrapper class="AnnouncementsContainer">
    <AnnouncementList>
      <PrecatorioAnticipationAnnouncementContainer />
    </AnnouncementList>
  </ContainerWrapper>
</template>
<script>
import ContainerWrapper from '@/components/ui/newComponents/ContainerWrapper.vue'
import AnnouncementList from '~/components/announcement-list/AnnouncementList.vue'
import PrecatorioAnticipationAnnouncementContainer from '~/containers/loans/announcements/precatorio-anticipation/PrecatorioAnticipationAnnouncementContainer.vue'

export default {
  name: 'AnnouncementsContainer',
  components: {
    PrecatorioAnticipationAnnouncementContainer,
    AnnouncementList,
    ContainerWrapper,
  },
}
</script>
<style lang="scss"></style>
